import React from "react";
import {Box} from "@mui/material";
import {GraphQlDataGrid, nestedValueGetter} from "../../../../components/common/grid/GraphQlDataGrid";
import {graphQLServices} from "../../../../services/GraphQLServices";
import {GridFilterItem} from "@mui/x-data-grid/models/gridFilterItem";
import {GET_REFBESLOOKUP} from "../graphql/queries/gqlGetRefBesLookup";
import {translateFunction} from "../../../../localization/TranslationService";

const translate = translateFunction();

interface IRefBesLookup {
	onRowClick?: (row: any) => void;// GridEventListener<"rowClick">;
	defaultFilter?: GridFilterItem[];
	labelId: string;
	activeOnly: boolean;
	autoSelectSingleRecord?: boolean;
}

const defaultFilter = [
	{
		field: "key",
		operator: "equals",

	},
	{
		field: "omschrijving",
		operator: "startsWith",
	},

];

export const RefBesLookup: React.FC<IRefBesLookup> = (props) => {

	const filter = defaultFilter.filter((it) => props.defaultFilter &&  (props.defaultFilter.filter((x) => x.field === it.field  ).length === 0));

	return (
		<Box>

			<GraphQlDataGrid
				infiniteLoading={true}
				hideExportButton
				gridHeight={800}
				enableHeaderFilter
				client={graphQLServices.documentsClient}
				query={	GET_REFBESLOOKUP }
				defaultSortModel={[
					{
						field: "omschrijving",
						sort: "asc"
					}
				]}
				defaultFilterModel={{
					items: [...filter??[],...props.defaultFilter??[]]
				}}

				columns={[
					{
						field: "key",
						headerName: translate("Key"),

						width: 150,
						sortable: false,
						type: "string",

					},
					{
						field: "omschrijving",
						headerName: translate("Description"),
						valueGetter: nestedValueGetter,
						width: 300,
						sortable: true,
					}
				]}
				graphFunction={
					"refBesLookup"
				}
				onDataFetched={(items) => {
					if (items.length === 1) {
						//const params: GridRowParams<any> = items[0];
						// TODO auto select if 1 item, issue with this line is that search button is not working anymore
						props.onRowClick && props.onRowClick(items[0]);
					}
				}}
				queryVariables={{"activeOnly": props.activeOnly, "labelId": props.labelId}}
				rows={[]}
				getRowId={(item:any)=> item.key}
				initialPageSize={200}
				rowsPerPageOptions={[200]}
				//autoHeight={true}
				//disableColumnFilter
				//disableColumnMenu
				autoSelectSingleRecord={props.autoSelectSingleRecord}
				onAutoSelect={(row) => props.onRowClick && props.onRowClick(row)}
				onRowClick={(params) => props.onRowClick && props.onRowClick(params.row)}
			/>

		</Box>
	);
};
